import React, { Suspense, useEffect } from "react";
import Navbar from "./components/utils/Navbar";
import ModalContact from "./components/utils/ModalContact";
// import ScrollToTop from "./components/utils/ScrollToTop";
import { useLocation } from 'react-router-dom';
import Reservacion from "./components/pages/Reservacion";
import EscogeTuVehiculo from "./components/pages/EscogeTuVehiculo";
import NotFound from "./components/pages/NotFound";
import Loading from "./components/pages/Loading";
import Crashing from "./components/pages/Crashing";
import "moment/locale/es";
import { BrowserRouter as Router, Route, Switch, Redirect, } from "react-router-dom";
import { useSelector } from "react-redux";
import "./sass/Navbar.scss";
import "./sass/Utils.scss";
import ReactGA from "react-ga4";
import { GA4, PIXEL } from "./helpers/IDTags.js";
import ReactPixel from 'react-facebook-pixel';
//import { Container } from 'react-floating-action-button'
//import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//import FormVehiculos from './components/pages/FormVehiculos';

const options = {
  autoConfig: true,
  debug: true,
};

ReactPixel.init(PIXEL, options);
ReactGA.initialize(GA4);

const trackPageview = (pathname) => {
  ReactGA.set({ page: pathname });
  ReactGA._gaCommandSendPageview(document.location.pathname)
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    //Realiza el seguimiento de la página cada vez que cambia la ruta
    trackPageview(pathname);
    //Realiza el seguimiento de la página cada vez que cambia la ruta PIXELS FACEBOOK
    ReactPixel.pageView();
  }, [pathname]);

  return null;
};

const Nosotros = React.lazy(() => import("./components/pages/Nosotros"));
const Politicas = React.lazy(() => import("./components/pages/Politicas"));
const Ubicaciones = React.lazy(() => import("./components/pages/Ubicaciones"));
const CategoriaVehiculos = React.lazy(() => import("./components/pages/CategoriaVehiculos"));


function App() {
  const isCrashed = useSelector((state) => state.crashing);
  

  return (
    <div className="App">
      <Suspense fallback={<Loading />}>
        <Router>
          <Navbar />

          {isCrashed && <Crashing />}
          <ModalContact onSubmit={() => { }} />
          <ScrollToTop />
          <Switch>
            <Route
              exact={true}
              path="/reservaciones"
              component={Reservacion}
            />

            <Route path="/escogetuvehiculo/*" component={EscogeTuVehiculo} />
            <Route exact={true} path="/coberturasyserviciosadicionales" component={EscogeTuVehiculo} />
            <Route exact={true} path="/graciasreserva" component={EscogeTuVehiculo} />
            <Route exact={true} path="/informarciondelcliente" component={EscogeTuVehiculo} />
            <Route exact={true} path="/confirmacion" component={EscogeTuVehiculo} />
            <Route exact={true} path="/nosotros" component={Nosotros} />
            <Route exact={true} path="/politicas" component={Politicas} />
            <Route exact={true} path="/ubicaciones" component={Ubicaciones} />
       
            <Route
              exact={true}
              path="/vehiculos"
              component={CategoriaVehiculos}
            />
            <Route
              exact={true}
              path="/vehiculos/sedan"
              component={CategoriaVehiculos}
            />
            <Route
              exact={true}
              path="/vehiculos/suv"
              component={CategoriaVehiculos}
            />
            <Route
              exact={true}
              path="/vehiculos/pickup"
              component={CategoriaVehiculos}
            />
            <Route
              exact={true}
              path="/vehiculos/minivan"
              component={CategoriaVehiculos}
            />
            <Route
              exact={true}
              path="/vehiculos/van"
              component={CategoriaVehiculos}
            />
            <Route exact path="/inicio">
              {<Redirect to="/reservaciones" />}
            </Route>
            <Route exact path="/">
              {<Redirect to="/reservaciones" />}
            </Route>
            <Route path="/landing/*" render={() => null} />            
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Router>
      </Suspense>
      {/*
      <Container className="FloatingButton" >
        <a className=" icon-whatsapp fab-link fab-item fab-rotate " 
        href={enlaces.find(w => w.Id === "FBUTTON")?.URL === undefined ? "#" : enlaces.find(w => w.Id === "FBUTTON")?.URL} 
        target="_blank"
        rel="noopener noreferrer"
        ><i className="Fbitem"><FontAwesomeIcon icon={faWhatsapp} /></i></a>
      </Container>
      */}
    </div>
  );
}


export default App;
